/* eslint-disable @typescript-eslint/naming-convention */
export const MODAL_ROUTES = {
	MODAL_OUTLET: 'modal',
	CANCEL_CHANGE_ORDER_PATH: 'cancel-change-order',
};
